import { createFileRoute, useRouter } from "@tanstack/react-router";

import { NewServicePage } from "@/features/catalog/pages";

export const Route = createFileRoute("/_app/catalog/services/new")({
  component: NewService,
});

function NewService() {
  const router = useRouter();
  return (
    <NewServicePage
      onCreated={(serviceId) =>
        void router.navigate({
          to: "/catalog/services/$serviceId",
          params: { serviceId },
          replace: true,
        })
      }
      onCancel={() => void router.navigate({ to: "/catalog/services" })}
    />
  );
}
